module.exports = __webpack_public_path__ + "img/terroir-redshift-4.a07b3395.jpg";